<template>
  <div class="page">
    <video class="bg" autoplay muted loop playsinline poster="./assets/o.jpg">
      <source src="./assets/o.mp4" type="video/mp4">
    </video>
    <div class="bg" style="display: block; background: rgba(0,255,196,0.31)"></div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
    this.init()
  },
  metaInfo() {
    return {
      title: 'СПАСИБО',
      meta: [
        {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'}
      ]
    }
  },
  methods: {
    init() {
      console.log('app init')
      console.log(localStorage.getItem('phone'))
      console.log(localStorage.getItem('code'))
      if (localStorage.getItem('phone') !== null && localStorage.getItem('code') !== null) {
        this.$router.push('/profile')
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  font-family: 'Fira Sans', sans-serif;
}

.bg {
  object-fit: cover;
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh
}

body {
  background: url('./assets/o.jpg') center center / cover no-repeat;
}

html, body, #app, .page, .page-list {
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
}
.page, .page-list  {
  width: 100%;
}

.page {
}

.page-list {
  display: block;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.95);
  height: 100%;
  min-height: 100%;
  padding-bottom: 24px;
}

.page-title {
  padding: 24px 16px 16px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-items: center;
  color: #404344;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 0.35px;
  font-family: 'Exo 2';
}

.page-title svg {
  padding-top: 8px;
  padding-right: 16px;
}

.page-subtitle {
  color: #565656;
  text-align: center;
  padding: 0 24px 16px;
  font-size: 14px;
  letter-spacing: 0.35px;
}

.page-uptitle {
  color: #565656;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0.35px;
}

.page-title-image {
  width: 1.4em;
  margin-left: auto;
  margin-right: 0;
  padding-bottom: 3px;
  color: #20bf6b;
}
.page-title-image-bg {
  width: 3.4em;
  height: 3.4em;
  margin-left: auto;
  margin-right: 0;
  padding-bottom: 3px;
  color: #20bf6b18;
  position: absolute;
  top: 10px;
  right: 10px;
}
.card {
  background: #fff;
  width: calc(100% - 74px) !important;
  margin: 16px 16px 0;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 0.1);
  box-shadow: 0 3px 9px rgba(128, 128, 128, 0.125);
}
.card-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  margin-bottom: 6px;
  color: #404344;
}
.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #404344;
  letter-spacing: .5px;
  padding-right: 32px;
  display: flex;
  align-items: center;
}
.card-subtitle {
  font-size: 14px;
  font-weight: 300;
  color: #595959;
  margin-top: 6px;
  font-family: 'Exo 2';
  line-height: 1.4;
}
.card-bonuses {
  font-size: 18px;
  font-weight: 100;
  color: tomato;
  color: #20bf6b;
  margin-top: 6px;
}
.groups {
  padding: 16px;
}
.group {
  background: #0984e377;
  color: white;
  display: inline-block;
  margin: 0 12px 8px 0;
  padding: 6px 16px 5px;
  border-radius: 11px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.group-active {
  background: #0984e3;
}
.page-title {
  position: relative;
}

</style>
